import { Route, Switch, Router as WouterRouter } from 'wouter';
import { PageLayout } from './components/SiteShell';
import {
  AboutPage, ContactPage, DisclaimerPage, GetListedPage, HomePage, HostelsPage, JobsPage, NotFoundPage,
  PartnersPage, PrivacyPage, ReportPage, ScholarshipsPage, ServicesPage, StudyAbroadPage,
  TermsPage, UniversitiesPage,
} from './pages/SitePages';

function Router() {
  return <PageLayout><Switch>
    <Route path="/" component={HomePage} />
    <Route path="/hostels" component={HostelsPage} />
    <Route path="/scholarships" component={ScholarshipsPage} />
    <Route path="/jobs" component={JobsPage} />
    <Route path="/study-abroad" component={StudyAbroadPage} />
    <Route path="/universities" component={UniversitiesPage} />
    <Route path="/student-services" component={ServicesPage} />
    <Route path="/about" component={AboutPage} />
    <Route path="/partners" component={PartnersPage} />
    <Route path="/get-listed" component={GetListedPage} />
    <Route path="/contact" component={ContactPage} />
    <Route path="/privacy" component={PrivacyPage} />
    <Route path="/terms" component={TermsPage} />
    <Route path="/report" component={ReportPage} />
    <Route path="/disclaimer" component={DisclaimerPage} />
    <Route component={NotFoundPage} />
  </Switch></PageLayout>;
}

function App() {
  return <WouterRouter base={import.meta.env.BASE_URL.replace(/\/$/, '')}><Router /></WouterRouter>;
}

export default App;
